export const PROJECT_NAME = 'lexia';
export const DISPLAY_NAME = 'Patternflow';

export const isDevelopmentBuild = process.env.NODE_ENV === 'development';

export type TimestampMillis = number;